<template>
  <v-app id="app">
    <router-view />
    <ex-alert />
    <alert-link/>
  </v-app>
</template>

<script>
// import Alert from "@/components/Utils/Alert.vue";
// import $ from "jquery";

import jsonData from '../public/domainConfig.json';
import { chainService } from "@/_services/ChainManage/chain.service.js";

export default {
  name: "App",
  components: {
    // "ex-alert": Alert
    "ex-alert": () => import('@/components/Utils/Alert.vue'),
    "alert-link": () => import('@/components/Utils/AlertLink.vue'),
  },
  data() {
    return {
      authenticated: true,
      domainData: jsonData,
      appVersion: null,
      versionLoaded: false,
      publicPath: [
        "",
        "/", 
        "/login", 
        "/change-pass", 
        "/register", 
        "/admin/login",
        "/logout"
      ],
    };
  },
  mounted() {
    const data = this.domainData[this.domain] ? this.domainData[this.domain] : null
    if (data) {
      const head = document.getElementsByTagName('HEAD')[0];
      const style = document.createElement('style');
      style.type = 'text/css';
      style.textContent = `
        .v-tabs .v-slide-group__content .v-tab.v-tab--active {
          color: ${data.primaryColor} !important;
          border-bottom: solid 3px ${data.primaryColor} !important;
        }
        #app {
          .primary {
              background-color: ${data.primaryColor} !important;
              border-color: ${data.primaryColor} !important;
          }
          .text-primary, .btn-outline-custom::before, a, .b-percen {
            color: ${data.primaryColor} !important;
          }
          .v-icon.v-icon.v-icon--link, .v-input--selection-controls__ripple, .v-input--selection-controls__input .v-icon, .primary--text {
            color: ${data.primaryColor} !important;
            caret-color: ${data.primaryColor} !important;
            &.v-chip__close {
              color: #fff !important;
            }
          }
          .vue-treeselect__multi-value-item, #upload-controller .dropbox label[for=input-file], #nav-wrapper, .progress-bar {
            background: ${data.primaryColor} !important;
          }
        }
      `;
      head.appendChild(style);
    }
    

    var meta = document.createElement('meta');
    if (this.mobiTablet) {
      meta.name = "viewport";
      meta.content = "width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0, viewport-fit=cover";
    } else {
      meta.name = "viewport";
      meta.content = "width=1124px";
    }
    document.getElementsByTagName('head')[0].appendChild(meta);
    var favicon = document.getElementById('favicon');
    if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || this.domain == 'localhost') {
      favicon.href = "/favicon.ico";
      if (this.$i18n.locale !== "vi") {
        document.title = "ezCrs - Central Reservation System";
      } else {
        document.title = "ezCrs - Hệ thống đặt phòng tập trung";
      }
    } else {
      favicon.href = "/favicon2.ico";
      if (this.$i18n.locale !== "vi") {
        document.title = "Central Reservation System";
      } else {
        document.title = "Hệ thống đặt phòng tập trung";
      }
    }
  },
  methods: {
    isTokenValid(token) {
      try {
        const payloadBase64 = token.split('.')[1];
        const payloadJson = atob(payloadBase64);
        const payload = JSON.parse(payloadJson);
        const currentTime = Math.floor(Date.now() / 1000);

        if (payload.iat && payload.iat > currentTime) {
          return false;
        }
        if (payload.exp && payload.exp < currentTime) {
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    async getVersion() {
      return await chainService.getVersion().then(res => res.data);
    },
    async loadVersion() {
      const data = await this.getVersion();
      this.appVersion = data.app_version;
      this.versionLoaded = true;
    },
    async clearAllCaches() {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
      }
      location.reload(true);
    },
  },
  watch: {
    $route(newRoute) {
      if (this.publicPath.includes(this.$route.path)) {
        return;
      }
      const currentUser = JSON.parse(localStorage.getItem('currentUser')) || null;
      if(!currentUser || !this.isTokenValid(currentUser.token)) {
        return;
      }
      
      if (!this.versionLoaded || !this.appVersion) {
        this.loadVersion();
      }

      if (this.appVersion) {
        const currentVersion = localStorage.getItem('app_version') || null;
        if (!currentVersion || this.appVersion !== currentVersion) {
          localStorage.setItem('app_version', this.appVersion);
          this.clearAllCaches();
        }
      }
    }
  },
  created() {}
};
</script>

<style lang="scss"> 
#app {
  font-family: "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
